import React from "react";
import { FONTS } from "@app/constants/STYLES";
import { MarketTableListContainer } from "../styles";
import Favourite from "./Favourite";
import { TradingParisContent, TradingParisSection } from "./styles";
import { CoinLogo } from "@app/components";
import { Text } from "@/styles/reactnative";
import { useNavigate } from "react-router-dom";

const TradingPairs = ({ data: item }) => {
  const navigation = useNavigate();
  console.log('📊 TradingPairs item:', item);
  return (
    <MarketTableListContainer
      onClick={() => {
        navigation(`/trade/${item?.ep_id || item?.id}`);
      }}
    >
      <TradingParisSection>
        <Favourite item={item} />
        <CoinLogo
          src={item?.image}
          style={{
            marginRight: 5,
            alignSelf: "center",
            display: "flex",
          }}
        />

        <TradingParisContent>
          <Text
            size={12}
            style={{
              ...FONTS.h7,
            }}
          >
            {item?.pairs}
          </Text>
        </TradingParisContent>
      </TradingParisSection>
    </MarketTableListContainer>
  );
};

export default TradingPairs;
